import { Decimal } from 'decimal.js';
import { PromotionCreditType } from '../../constants/promotion-credit-type.js';
import { parseCalendarDate } from '../../dates/index.js';
import { haveCreditLinesChanged } from './have-credit-lines-changed.js';
import { toCreditLineInput } from './to-credit-line-input.js';
const changedOrUndefined = (next, current) => next === current ? undefined : next;
// An absent field leaves the stored value alone, and null clears it.
function changedText(next, current) {
    const trimmed = next.trim();
    return trimmed === (current ?? '').trim() ? undefined : trimmed || null;
}
function toUpdateLineInput(line) {
    return line.id ? { id: line.id, ...toCreditLineInput(line) } : toCreditLineInput(line);
}
// Lines belong only to a Promotion credit with a linked promotion, so when it stops being one they go in the same edit.
function linesToSend(values, stored) {
    const canKeepLines = values.promotionCreditTypeId === String(PromotionCreditType.PROMOTION) &&
        values.promotionId !== '';
    if (!canKeepLines)
        return stored.lines.length > 0 ? [] : undefined;
    return haveCreditLinesChanged(values.lines, stored.lines)
        ? values.lines.map(toUpdateLineInput)
        : undefined;
}
function changedPromotionId(values, stored) {
    const next = values.promotionId.toLowerCase() || null;
    const current = stored.promotionId?.toLowerCase() ?? null;
    return next === current ? undefined : next;
}
/** Sends only what the edit changes: the API treats a resent stored amount or lines as noise, and an edit with no fields is refused. */
export function toUpdatePromotionCreditInput(values, stored) {
    const amount = Number(values.amount);
    const lines = linesToSend(values, stored);
    // While stored lines exist the amount is derived from them, so it travels only with a line change.
    const amountMoved = !new Decimal(amount).equals(stored.amount);
    const sendAmount = amountMoved && (lines !== undefined || stored.lines.length === 0);
    const expirationDate = changedOrUndefined(values.expirationDate, stored.expirationDate);
    return {
        promotionCreditTypeId: changedOrUndefined(Number(values.promotionCreditTypeId), stored.promotionCreditTypeId),
        amount: sendAmount ? amount : undefined,
        dateApplicable: changedOrUndefined(values.dateApplicable, stored.dateApplicable),
        expirationDate: expirationDate === undefined ? undefined : parseCalendarDate(expirationDate),
        details: changedText(values.details, stored.details),
        notes: changedText(values.notes, stored.notes),
        promotionId: changedPromotionId(values, stored),
        lines,
    };
}
//# sourceMappingURL=update-mapper.js.map